import React from 'react';
import classnames from 'classnames';
import { AccentRadioButton } from '../RadioButton';
import { Body, Small } from '../text';
import { textOverflow } from 'scy/utils.mod.scss';
import styles from './styles.mod.scss';

export default function RadioListItem({
  mainContentClass,
  autoHeight,
  title,
  subtitle,
  highlightSubtitle,
  aside,
  checked,
  disabled,
  ...restButtonProps
}) {
  const radioButtonProps = {
    containerClass: classnames(styles.row, {
      [styles.disabledRow]: disabled
    }),
    containerTag: 'li',
    labelClass: classnames(styles.label, {
      [styles.defaultLabelHeight]: !autoHeight
    }),
    checked,
    disabled,
    ...restButtonProps
  };

  const textProps = {
    tag: 'div',
    className: classnames(textOverflow, {
      [styles.checkedText]: checked,
      [styles.disabledText]: disabled
    })
  };

  const subtitleClassName = classnames(styles.subtitle, {
    [styles.alertText]: highlightSubtitle && !checked,
    [styles.checkedText]: checked,
    [styles.disabledText]: disabled
  });

  return (
    <AccentRadioButton {...radioButtonProps}>
      <div className={classnames(styles.mainContent, mainContentClass)}>
        <Body {...textProps}>{title}</Body>
        {!!subtitle && <Small className={subtitleClassName}>{subtitle}</Small>}
      </div>
      {!!aside && <Body {...textProps}>{aside}</Body>}
    </AccentRadioButton>
  );
}
